import React, { useEffect, useState } from "react";
import { useCompany } from "../hooks/useCompany";
import InsuranceProviderModal from "../components/Modal/InsuranceProviderModal";
import { Link } from "react-router-dom";
import { Paths } from "../router/Paths";
import { InsuranceProvidersType } from "../types/loadedData";
import { useSelector } from "react-redux";

export default function LegalRequirements() {
  const [modalState, setModalState] = useState(false);
  const { getAllProviders, deleteInsuranceProvider, updateInsuranceProvider } =
    useCompany();
  const [insuranceProviders, setInsuranceProviders] = useState<
    InsuranceProvidersType[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [selectedProvider, setSelectedProvider] =
    useState<InsuranceProvidersType | null>(null);

  // const {insuranceProvider} = useSelector(state => state.company)

  const openModal = () => setModalState(true);
  const closeModal = () => setModalState(false);

  const openEditModal = (provider: InsuranceProvidersType) => {
    setSelectedProvider(provider);
    setModalState(true);
  };

  // const mockData = [
  //   {
  //     id: 1,
  //     title: "Provider 1",
  //     description: "Description for provider 1",
  //     logo: null,
  //   },
  //   {
  //     id: 2,
  //     title: "Provider 2",
  //     description: "Description for provider 2",
  //     logo: null,
  //   },
  //   {
  //     id: 3,
  //     title: "Provider 3",
  //     description: "Description for provider 3",
  //     logo: null,
  //   },
  // ];

  const fetchInsuranceProviders = async () => {
    setLoading(true);
    try {
      const response = await getAllProviders({ page: 1, limit: 5 });
      console.log("API insurance Response:", response); // Debugging log
      const providers = response?.insurance_provider;
      console.log("Parsed Providers:", providers); // Debugging log
      setInsuranceProviders(providers);
    } catch (error) {
      console.error("Error fetching insurance providers:", error); // Debugging log
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInsuranceProviders();
  }, []);

  const handleDeleteProvider = (id: string) => async () => {
    setLoading(true);
    try {
      const response = await deleteInsuranceProvider({ id, setLoading });
      console.log("Delete insurance Response:", response); // Debugging log

      if (response?.success) {
        await fetchInsuranceProviders(); // Fetch providers again after deletion
        console.log("Insurance provider deleted successfully."); // Debugging log
      } else {
        console.error("Failed to delete insurance provider."); // Debugging log
      }
    } catch (error) {
      console.error("Error deleting insurance provider:", error); // Debugging log
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4 ">
      {/* Insurance Section */}
      <div className="border border-gray-300 rounded-lg p-6 bg-white">
        <h2 className="font-semibold text-xl">Insurance</h2>
        <p className="text-gray-600 mt-2">
          One or more of your activities requires liability insurance. Every
          supply partner on Intraverse needs to maintain comprehensive general
          liability insurance covering risks related to the business and the
          services. Please enter your information here.
        </p>
        {/* insurance provider list  */}
        {loading ? (
          <p className="mt-4 font-semibold">Loading insurance providers...</p>
        ) : insuranceProviders && insuranceProviders.length > 0 ? (
          insuranceProviders.map((provider, index) => (
            <div key={index} className="flex justify-between items-center mt-4">
              <div className="flex items-center">
                {provider.logo && (
                  <img
                    src={
                      typeof provider.logo === "string"
                        ? provider.logo
                        : URL.createObjectURL(provider.logo)
                    }
                    alt={provider.title}
                    className="w-10 h-10 rounded-full mr-4"
                  />
                )}
                <div>
                  <h3 className="font-semibold">{provider.title}</h3>
                  <p className="text-gray-600">{provider.description}</p>
                </div>
              </div>
              <div>
                <button
                  className="text-blue-600 hover:text-blue-800 mr-4"
                  onClick={() => openEditModal(provider)}
                >
                  Edit
                </button>
                <button
                  className="text-red-500 hover:text-red-700"
                  onClick={handleDeleteProvider(provider._id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))
        ) : (
          <p className="mt-4 font-semibold">
            No insurance providers found. Please add one.
          </p>
        )}
        <button
          onClick={openModal}
          className="mt-4 px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50"
        >
          Add new insurance provider
        </button>
      </div>

      <InsuranceProviderModal
        fetch={fetchInsuranceProviders}
        isOpen={modalState}
        onClose={closeModal}
        provider={selectedProvider}
        setProvider={setSelectedProvider}
      />

      {/* Terms and Conditions Section */}
      <div className="border border-gray-300 rounded-lg p-6 bg-white">
        <h2 className="font-semibold text-xl">Terms and conditions</h2>
        <p className="text-gray-600 mt-2">
          The contractual relationship between your company and any customer.
          Customers receive these by email after they book an activity on
          Intraverse and can see them on your Intraverse activity provider
          profile page.
        </p>

        <div className="mt-4 space-y-4">
          <div className="flex justify-between">
            <span className="font-semibold">General terms and conditions</span>
            <p className="text-gray-600 max-w-sm">
              The Intraverse general terms and conditions (for reference only).
              This is the default contract between you and the customer, and
              exists in every language published on the Intraverse website
              (except non-Latin alphabet languages).
            </p>
          </div>

          <div className="flex justify-between items-center">
            <span className="font-semibold">
              Activity provider terms and conditions (optional)
            </span>
            <div className="text-gray-400 ml-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 00-2 0v3a1 1 0 00.293.707l2 2a1 1 0 101.414-1.414L11 9.586V6z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Policy Section */}
      <div className="border border-gray-300 rounded-lg p-6 bg-white">
        <h2 className="font-semibold text-xl">Privacy policy</h2>
        <p className="text-gray-600 mt-2">
          Your company’s protocols and guidelines around handling data that
          customers share with you or through Intraverse, e.g. phone numbers.
          This will be visible to customers on your Intraverse activity provider
          profile page.
        </p>
        <Link
          to={Paths.privacyPolicy}
          className="mt-4 px-4 py-2 text-blue-600 underline"
        >
          Privacy policy
        </Link>
      </div>
    </div>
  );
}
